<div>
    <div class="main">
        <section class="admin-content">
            <div class="tab-content  custom-tab-content">
                <div class="view-users">
                    <div id="user-view" class="show">
                        <div class="color-blue mb-20">{{'user.USER INFORMATION' |translate}}</div>
                        <div class="row">
                             <div class="col-xs-5">
                                <div class="row form-group">
                                    <div class="col-sm-6"> {{'user.Login ID' |translate}}</div>
                                    <div class="col-sm-6 text-right">{{loginId}}</div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-5">{{'user.First Name' |translate}}</div>
                                    <div class="col-sm-7 text-right">{{userName |translate}}</div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-3">{{'user.Email' |translate}}</div>
                                    <div class="col-sm-9 text-right"><a href="mailto:{{email}}">{{email}}</a></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-3">{{'user.Phone' |translate}}</div>
                                    <div class="col-sm-9 text-right">{{phoneNumber}}</div>
                                </div>
                            </div> 
                            <div class="col-xs-7"></div>
                        </div>
                        
                    <!--<form [formGroup]="userUpdateForm" class=" color-validation " novalidate (ngSubmit)="onSubmit()">  -->
                        <!--<div class="color-blue">{{'user.Role' |translate}}</div>-->
                        <div class="form-group col-xs-4 multi-select  no-padding role-multiselect" [ngClass]="{'ng-invalid': isRolesSelected == true, 'ng-valid': isRolesSelected == false}"> 
                            <angular2-multiselect tabindex="0" id="role" #dropdownElem (blur)="close($event)"
                            [data]="dropdownSettings.rolesDropdown" [(ngModel)]="dropdownSettings.roleSelectedItems" 
                            [settings]="dropdownSettings.settings" 
                            (onSelect)="onItemSelect($event,dropdownSettings.roleIndex)"
                            (onDeSelect)="onItemDeSelect($event,dropdownSettings.roleIndex)" 
                            (onSelectAll)="onSelectAll($event,dropdownSettings.roleIndex)" 
                            (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.roleIndex)" >
                            </angular2-multiselect>    
                            <div class="alert-msg" *ngIf="isRolesSelected== true">{{'validation-message.Role is required'|translate}}</div>                         
                            <!--<ng-selectize tabindex="0" formControlName="roleUpdateIds"  [config]="rolesDropdownConfig" ngDefaultControl [options]="rolesDropdownOptions"
                                (ngModelChange)="onValueChangeForUpdateUser($event)"  placeholder="{{'user.Select Role' | translate}}">
                            </ng-selectize>-->
                        </div>  

                        <!-- Roles, Permissions Grid --> 
                             <div class="table-responsive mb-20 multipleassign-table no-overflow">
                                <table class="table table-striped custab">
                                    <thead>
                                        <tr>
                                            <th>{{'user.Permission' |translate | translateKey}}</th>
                                            <th colspan="7">{{'user.Assign' |translate | translateKey}}</th> 
                                            <!--<th class="text-center" *ngFor="let header of permissionHeaders">{{header}}</th>-->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let permissionGroup of departmentLevelPermissionGroupList">
                                            <td class="tablerow">                                               
                                                {{permissionGroup.permissionGroupName}}
                                            </td>
                                            <td class="text-center tablerow" *ngFor="let header of permissionHeaders">
                                                <label *ngFor="let permission of permissionGroup.permissionModels">
                                                    <span *ngIf="permission.permissionName==header">
                                                        <input tabindex="0" type="checkbox" attr.id="permission-{{permissionGroup.permissionGroupId+'-'+permission.permissionId}}" value="permission.permissionId"
                                                            (change)="updateCheckedOptions(permission,permissionGroup, $event)"
                                                            [checked]="permission.selected">
                                                            {{permission.permissionName}}
                                                    </span>
                                                </label> 
                                                <label *ngIf="isPermissionAvailable(permissionGroup.permissionModels,header)" class="font-10"> {{'user.N/A'|translate}} </label>
                                            </td>
                                            </tr>
                                    </tbody>
                                </table>
                            </div> 
                             <div>
                            <div class="mb-20 text-right">
                                <button class="btn blue-button btn-save" tabindex="0" type="button" (keyup.enter)="onSubmit()" (click)="onSubmit()">{{'user.MODIFY' |translate |translateKey}}</button>
                                &nbsp;<button type="button" tabindex="0" (keyup.enter)="clearFormData(4)" class="btn cancel grey-button" (click)="clearFormData(4)">{{'user.Cancel' |translate |translateKey}}</button>
                            </div>
                            
                        </div>
                     <!--</form>-->
                    </div> 
                </div>
            </div>
        </section>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department-manage-user.component.html